/* eslint-disable react-refresh/only-export-components */
import { createContext, Dispatch, useContext } from 'react';
import { ZieleEditForm, ZieleFormReducerAction } from '../types';
import { useZieleFormReducer } from './useZieleFormReducer';

type DialogContextProps = {
  zieleForm: ZieleEditForm;
  dispatch: Dispatch<ZieleFormReducerAction>;
};

export const DialogContext = createContext<DialogContextProps | undefined>(
  undefined,
);

function DialogContextProvider({ children }: { children: React.ReactNode }) {
  const [zieleForm, dispatch] = useZieleFormReducer();

  const value: DialogContextProps = { zieleForm, dispatch };

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
}

function useDialogContext() {
  const dialogContext = useContext(DialogContext);

  if (dialogContext === undefined) {
    throw new Error(
      'useDialogContext must be used within DialogContextProvider',
    );
  }
  return dialogContext;
}

export { useDialogContext, DialogContextProvider };
